import { render, staticRenderFns } from "./CancelamentoProtesto.vue?vue&type=template&id=2403c800&scoped=true"
import script from "./CancelamentoProtesto.vue?vue&type=script&lang=js"
export * from "./CancelamentoProtesto.vue?vue&type=script&lang=js"
import style0 from "./CancelamentoProtesto.vue?vue&type=style&index=0&id=2403c800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2403c800",
  null
  
)

export default component.exports